<template>
  <nav class="set_product_type">
    <button type="button"
      v-for="{prefix, name, type, feature, slatWidth, shield, weight_bar, display, default: itemList, subName } in typeList"
      :key="type"
      class="product_type__btn"
      :class="{
        long: name.length > 10,
        picked: isPicked(type),
        column: subName,
        [`prefix-${prefix}`]: true
      }"
      :disabled="isPicked(type)"
      @click.stop="updateProductType(prefix, type, feature, slatWidth, shield, weight_bar, display, itemList, $event)"
    >{{ name }}<span v-if="subName">({{ subName }})</span></button>
  </nav>
</template>

<script>
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
import disabledCtgList from '../../../assets/json/disabledCtgList.json'

export default {
  props: {
    typeList: {
      type: Array,
      default: () => [...Array(3)].map((_, idx) => (
        {
          name: 'ラインドレープ（スラット100mm）',
          type: idx
        }
      ))
    }
  },
  data () {
    return {
      typeInActive: ''
    }
  },
  computed: {
    ...mapState('simulator', ['slat_list']),
    ...mapGetters("simulator", ["editing_item", 'slat_category']),
    isPicked () {
      return (type) => this.typeInActive === type
    }
  },
  methods: {
    ...mapMutations(['setRectWidth', 'setRectHeight']),
    ...mapMutations('simulator', ['setDisableIdList']),
    ...mapActions('simulator', ['updateItemProductType', 'updateItemInfo', 'reverseSlatPairing', 'setSlatCtgSelected']),
    resetActiveType () {
      this.typeInActive = ''
    },
    async setProductType (
      prefix,
      type,
      feature,
      slatWidth,
      shield,
      weight_bar,
      display,
      itemList,
      reverse,
      is_upper_lace
      ) {
      const itemMeta = {prefix, type, feature, slatWidth, shield, is_upper_lace, display, progress: 2}
      return this.updateItemProductType(itemMeta).then(async () => {
          const defParts = []
          const item_data = itemList.reduce((acc, meta) => {
            const [myId, sfx] = typeof meta === 'object'
              ? [meta.id, `_${meta.suffix}`]
              : [meta, ''];
            const slat = this.slat_list.find(({id}) => id === myId)
            if (typeof slat === 'undefined') {
              console.log({msg: 'Texture Image Not Found', prefix, type, key: meta})
              return {
                name: meta,
                ...acc,
                [`name${sfx}`]: '',
                [`width${sfx}`]: 0,
                [`height${sfx}`]: 0
              }
            } else {
              defParts.push(slat.parts);
              return {
                name: meta,
                ...acc,
                [`name${sfx}`]: myId,
                [`width${sfx}`]: slat.width,
                [`height${sfx}`]: slat.height,
                [`ctgId${sfx}`]: slat.ctgId
              }
            }
          }, {})

          // 部品テープは item_data へ追加
          if (type === 'FT-CHAIN-TAPE-50') {
            item_data.name_tape = defParts[0].tape;
            item_data.width_tape = 200;
            item_data.height_tape = 200;
          }

          this.setRectWidth(this.editing_item.rect_width);
          this.setRectHeight(this.editing_item.rect_height);

          // const {width, height, parts} = slat
          const disabled_ctg_id = type in disabledCtgList
            ? reverse ? disabledCtgList[type].slice().reverse() : disabledCtgList[type]
            : [[]];
          await this.updateItemInfo({
            item_data,
            feature,
            disabled_ctg_id,
            display,
            parts: defParts[0] || 'undefined',
            slatWidth,
            shield,
            weight_bar,
            disable_parts: undefined,
            init: true
          })

          // 選択可能なカテゴリが1つだけなら選択状態にしておく
          // 選択できる生地が 1 or 2 かを判定
          const slatLength =
            !feature
            || ['normal', 'weightBar'].includes(feature.type)
            // 'LD-PE-100'はドレープとレースがあるので 2 になる特例処置
            && !['LD-PE-100'].includes(this.editing_item.productType) ? 1 : 2
          const preSelected = [...Array(slatLength).keys()].reduce((selected, _, idx) => {
            const selectable = this.slat_category.filter(ctg => !disabled_ctg_id[idx].includes(ctg.id))
            const sfx = idx === 0 ? '' : '2'
            if (selectable.length === 1) {
              return {
                ...selected,
                [`id${sfx}`]: selectable[0].id,
                [`name${sfx}`]: selectable[0].name
              }
            } else {
              return selected
            }
          }, {})
          this.setSlatCtgSelected(preSelected)
      })
    },
    async updateProductType (prefix, type, feature, slatWidth, shield, weight_bar, display, itemList, ev) {

      let reverse = false
      let is_upper_lace = false
      if (['ZF-FE-PAIR', 'PL-PAIR', 'HS-PAIR'].includes(type)) {
        this.typeInActive = type
        this.$emit('clearSettle')
        const result = await new Promise((resolve, reject) =>
          this.$emit('update:settle', { resolve, reject })
        )
          .then((res) => {
            reverse = res
            if (reverse) {
              itemList = [itemList[1].id, { id: itemList[0], suffix: 'bottom' }]
              is_upper_lace = true
            }
            return true
          })
          .catch(() => {
            return false
          })
        if (!result) {
          return false
        }
      } else {
        this.typeInActive = ''
        this.$emit('clearSettle')
      }

      let clearId = null
      await new Promise ((resolve) => {
        ev.target.addEventListener('animationend', () => {
          resolve()
        }, { once: true })
        clearId = setTimeout(() => resolve(), 100)
      }).then(async () => {
        clearId && clearTimeout(clearId)
        await this.setProductType(
          prefix,
          type,
          feature,
          slatWidth,
          shield,
          weight_bar,
          display,
          itemList,
          reverse,
          is_upper_lace
        )
        window.requestAnimationFrame(() => this.$emit('closeModal'))
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .set_product_type {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    margin: 0;
    padding: 5%;
    .product_type__btn {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: calc(6 / 158 * 100%);
      margin-bottom: 10px;
      width: 100%;
      font-size: clamp(10px, 1.2vw, 16px);
      word-break: keep-all;
      line-break: strict;
      word-wrap: break-word;
      overflow-wrap: break-word;
      white-space: pre-line;
      line-height: 1;
      list-style: none;
      background-color: white;
      border: none;
      border-radius: 6px;
      appearance: none;
      height: calc(30% - 10px);
      cursor: pointer;
      &.column {
        flex-direction: column;
      }
      &.prefix-T {
        padding-block: calc(2 / 158 * 100%);
        line-height: 1.1;
        &:nth-child(-n+3) {
          line-height: 2.2;
        }
      }
      &.arrowed::after {
        position: absolute;
        display: block;
        content: '';
        top: 12.5%;
        left: 100%;
        margin-left: 3.5%;
        background-color: #fff;
        width: 8%;
        height: 75%;
        clip-path: polygon(0 0, 100% 50%, 0 100%);
      }
      &.picked:disabled {
        color: #fff;
        background-color: #000;
      }
      &.long {
        font-size: clamp(10px, 1.2vw, 16px);
      }
      &:active {
        animation: pressed 80ms;
      }
      @keyframes pressed {
        50% {
          transform: translate3d((0, 2px, 0));
          background-color: #ddd;
        }
        to {
          transform: translate3d((0, 0, 0));
          background-color: white;
        }
      }
    }
    .product_type__btn:last-child {
      margin-bottom: 0;
    }
  }
</style>